<template>
  <div>
    <vs-alert :active.sync="errorOccurred" color="danger" title="Error While Loading Lesson">
      <span>We were unable to load Lesson with Id {{ $route.params.lessonId }} successfully.</span>
    </vs-alert>
    <div v-if="!errorOccurred">

      <div v-if="lessonData">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vx-card>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <img v-if="lessonData.thumbnail" :src="lessonData.thumbnail" class="mr-4 rounded" height="40"
                       width="40">
                  <h1 class="">{{ lessonData.name }}</h1>
                </div>
                <div class="flex justify-end items-center">
                  <feather-icon v-if="autoSave.status === 'success'" icon="CheckIcon"
                                svgClasses="h-5 w-5 text-success mr-2"/>
                  <div v-else-if="autoSave.status === 'pending'" id="pendingLoadingCircle"
                       class="vs-con-loading__container h-5 w-5 mr-2"/>
                  <feather-icon v-else icon="XCircleIcon" svgClasses="h-5 w-5 text-danger mr-2"/>
                  <p class="cursor-pointer" @click="saveChanges">{{ autoSave.text }}</p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-5">
          <div class="vx-col w-2/3">
            <h1 class="font-bold mb-2 ml-2">Lesson Challenges</h1>
            <vx-card>
              <draggable :group="{name: 'challenges'}" :list="lessonData.challenges" class="cursor-move"
                         style="min-height: 15rem">
                <div v-for="(challenge, index) in lessonData.challenges">
                  <vs-collapse class="m-0 p-0">
                    <div class="border-white border-solid rounded mb-3">
                      <vs-collapse-item class="m-0 p-0">
                        <div slot="header" class="flex justify-between items-center p-3 pt-2 pb-2">
                          <h4 v-if="challenge.type === 'gap_fill'" class="font-bold">Challenge - Gap Fill</h4>
                          <h4 v-if="challenge.type === 'multi_choice'" class="font-bold">Challenge - Multi Choice</h4>
                          <h4 v-if="challenge.type === 'write'" class="font-bold">Challenge - Write</h4>
                          <div class="flex justify-end items-center">
                            <vs-button class="cursor-pointer z-10" color="primary" icon="icon-copy" icon-pack="feather"
                                       size="small"
                                       type="gradient" @click="copyText(challenge.id)" @click.stop>Copy Id
                            </vs-button>
                            <vs-button class="cursor-pointer ml-2 mr-1" color="danger" icon="icon-trash" icon-pack="feather"
                                       size="small"
                                       type="gradient" @click="confirmDeleteChallenge(challenge.id)"
                                       @click.stop>Delete
                            </vs-button>
                          </div>
                        </div>
                        <div class="p-5 pt-0">
                          <h4 class="text-light mb-2">Prompt</h4>
                          <vs-input v-model="challenge.prompt" class="w-full mb-5"
                                    @change="saveChanges(challenge, index)"/>

                          <div v-if="challenge.type === 'gap_fill'">
                            <h4 class="text-light mb-2">Title</h4>
                            <vs-input v-model="challenge.meta.title" class="w-full mb-5"  @change="saveChanges(challenge, index)"/>

                            <h4 class="text-light mb-2">Gap Fill Type</h4>
                            <vs-select v-model="challenge.meta.type" class="w-full mb-5"
                                       @change="saveChanges(challenge, index)">
                              <vs-select-item v-for="(option) in ['build','write']" :key="index"
                                              :text="option.charAt(0).toUpperCase() + option.slice(1)"
                                              :value="option"/>
                            </vs-select>

                            <div class="flex items-center mb-2">
                              <h4 class="text-light  mr-2">TTS Url</h4>
                              <feather-icon icon="Volume2Icon" svgClasses="w-5 h-5 hover:text-primary"
                                            @click="generateTTSAudio(challenge.meta.tts)"></feather-icon>
                            </div>
                            <vs-input v-model="challenge.meta.tts" class="w-full mb-5"
                                      @change="saveChanges(challenge, index)"/>

                            <h4 class="text-light mb-2">Choices</h4>
                            <vs-chips v-model="challenge.meta.choices" class="w-full mb-5" icon-pack="feather"
                                      placeholder="New Choice" remove-icon="icon-trash-2" @input="saveChanges(challenge, index)">
                              <vs-chip v-for="(chip, index) in challenge.meta.choices" :key="chip" closable
                                       color="primary"
                                       size="large" @click="challenge.meta.choices.splice(index, 1)">
                                {{ chip }}
                              </vs-chip>
                            </vs-chips>

                            <h4 class="text-light mb-2">Gap Fill Structure</h4>
                            <vs-button class="w-full" color="primary" type="gradient"
                                       @click="gapFillChallengeOpen(challenge, index)">Open Gap Fill Generator
                            </vs-button>
                          </div>

                        </div>
                      </vs-collapse-item>
                    </div>
                  </vs-collapse>
                </div>
              </draggable>
            </vx-card>
          </div>
          <div class="vx-col w-1/3">
            <h1 class="font-bold mb-2 ml-2">Add Challenge</h1>
            <vx-card class="mb-4">
              <div class="flex items-center justify-between">
                <h1>Gap Fill</h1>
                <feather-icon class="cursor-pointer" icon="PlusCircleIcon" svgClasses="h-8 w-8 hover:text-primary"
                              @click="createChallenge('gap_fill', 'Fill in the gaps below.')"/>
              </div>
            </vx-card>
            <vx-card class="mb-4">
              <div class="flex items-center justify-between">
                <h1>Multi Choice</h1>
                <feather-icon class="cursor-pointer" icon="PlusCircleIcon" svgClasses="h-8 w-8 hover:text-primary"
                              @click="createChallenge('multi_choice', 'Choose the correct answer below.')"/>
              </div>
            </vx-card>
            <vx-card class="mb-4">
              <div class="flex items-center justify-between">
                <h1>Write</h1>
                <feather-icon class="cursor-pointer" icon="PlusCircleIcon" svgClasses="h-8 w-8 hover:text-primary"
                              @click="createChallenge('write', 'Write the correct answer below.')"/>
              </div>
            </vx-card>
          </div>
        </div>
      </div>

      <div v-else class="simple-spinner">
        <span></span>
      </div>

    </div>

    <vs-popup id="GapFillGenerator" :active.sync="gapFillCreatorPopup" title="Gap Fill Generator">
      <h2 class="mb-3 font-bold">Type In Sentence</h2>
      <vs-input v-model="gapFillCreatorText" class="w-full" @keydown.enter="gapFillGenerate"></vs-input>

      <h2 class="mb-3 mt-8 font-bold">Words</h2>
      <div class="grid grid-cols-1 gap-3">
        <vs-collapse class="m-0 p-0">
          <div v-for="word in gapFillCreatorWords" v-if="word.text !== ' '"
               class="my-3 border-b-2 border-t-2 border-solid rounded">
            <vs-collapse-item class="m-0 p-0">
              <div slot="header" @click.stop class="pr-6">
                <vs-input v-model="word.text" class="w-full"></vs-input>
                <div class="flex items-center justify-between mt-2">
                  <h4>Fill</h4>
                  <vs-switch v-model="word.fill" class="mt-3" color="success"/>
                </div>
              </div>
              <div class="p-1">
                <div v-if="word.fill" class="">
                  <h4>Answers</h4>
                  <vs-chips v-model="word.answers" class="w-full mb-5 mt-1" icon-pack="feather" placeholder="New Answer"
                            remove-icon="icon-trash-2">
                    <vs-chip v-for="(chip, index) in word.answers" :key="chip" closable
                             color="primary"
                             size="large" @click="word.answers.splice(index, 1)">
                      {{ chip }}
                    </vs-chip>
                  </vs-chips>

                  <h4>Alt Answers</h4>
                  <vs-chips v-model="word.alt_answers" class="w-full mb-5 mt-1" icon-pack="feather"
                            placeholder="New Alt Answer" remove-icon="icon-trash-2">
                    <vs-chip v-for="(chip, index) in word.alt_answers" :key="chip" closable
                             color="primary"
                             size="large" @click="word.alt_answers.splice(index, 1)">
                      {{ chip }}
                    </vs-chip>
                  </vs-chips>

                  <div class="flex items-center justify-between mb-5">
                    <h4>Lenient</h4>
                    <vs-switch v-model="word.lenient" class="mt-3" color="success"/>
                  </div>

                  <h4>Width</h4>
                  <vs-input v-model="word.width" class="mt-3 w-full" color="success"/>
                </div>
              </div>
            </vs-collapse-item>
          </div>
        </vs-collapse>
      </div>
      <vs-button class="mt-2 mb-2" color="success" @click="gapFillSaveChanges">Save Changes</vs-button>
    </vs-popup>

  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '@/components/lottie/LottieAnimation'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      lessonData: null,
      errorOccurred: false,
      deleteChallengeId: null,
      ttsAudioPlayback: null,

      gapFillCreatorPopup: false,
      gapFillCreatorIndex: null,
      gapFillCreatorWords: [],
      gapFillCreatorText: '',

      autoSave: {
        status: 'success',
        text: 'Ready To Save'
      }

    }
  },
  computed: {
    lessonColorProgress () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgba(0,0,0,0.2)'
      if (theme === 'midnight') return 'rgba(0,0,0,0.5)'
      if (theme === 'dark') return 'rgba(0,0,0,0.2)'
    },
    isLessonChallengesEmpty () {
      return this.lessonData.challenges.length === 0
    },
  },
  components: {
    RadialProgressBar,
    LottieAnimation,
    draggable
  },
  methods: {
    copyText (x) {
      const thisIns = this
      this.$copyText(x).then(function () {
        thisIns.$vs.notify({
          title: 'Success',
          text: 'ID Copied to Clipboard',
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-clipboard'
        })
      })
    },
    createChallenge (type, prompt) {
      this.$vs.loading()
      const pl = {
        prompt: prompt ? prompt : '',
        type: type,
        meta: []
      }
      this.$http.post(`practice/challenges/create?lessonId=${this.lessonData.id}`, pl)
        .then(response => {
          if (response.status === 200) {
            this.saveChanges()
            this.fetchLessonDetails(this.lessonData.id)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Created Challenge Successfully',
              text: 'New challenge has been created.',
              color: 'success',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to create challenge')
        })
    },
    confirmDeleteChallenge (id) {
      this.deleteChallengeId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this challenge.',
        accept: this.deleteChallenge,
        acceptText: 'Confirm'
      })
    },
    deleteChallenge () {
      if (this.deleteChallengeId === null) return
      this.$vs.loading()
      this.$http.delete(`practice/challenges/${this.deleteChallengeId}`)
        .then(response => {
          this.saveChanges(null)
          this.deleteChallengeId = null
          if (response.status === 200) {
            this.fetchLessonDetails(this.lessonData.id)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Deleted Challenge Successfully',
              text: 'Challenge has been deleted.',
              color: 'success',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()
          this.handleError(exception, 'Failed to delete challenge')
        })
    },
    fetchLessonDetails (id) {
      this.$http.get(`practice/lessons/${id}?rich=true`)
        .then(response => {
          if (response.status === 200) {
            this.lessonData = response.data.data
          }
        })
        .catch(() => {
          this.errorOccurred = true
        })
    },
    gapFillChallengeOpen (challenge, index) {
      this.gapFillCreatorIndex = index
      this.gapFillCreatorWords = challenge.meta.words
      this.gapFillCreatorPopup = true
    },
    gapFillGenerate () {
      const split = this.gapFillCreatorText.split(/(\s+)/)
      this.gapFillCreatorWords = []
      split.forEach(item => {
        this.gapFillCreatorWords.push({
          text: item,
          answers: [],
          alt_answers: [],
          lenient: false,
          fill: false,
          width: null
        })
      })
    },
    gapFillSaveChanges () {
      this.lessonData.challenges[this.gapFillCreatorIndex].meta.words = this.gapFillCreatorWords
      this.saveChanges(this.lessonData.challenges[this.gapFillCreatorIndex])
      this.gapFillCreatorPopup = false
      this.gapFillCreatorIndex = null
    },
    generateTTSAudio (url) {
      this.ttsAudioPlayback = null
      this.ttsAudioPlayback = new Audio(url)
      this.ttsAudioPlayback.play()
    },
    handleError (exception, title, text) {
      let error = 'An unknown error occurred while adding term to set'
      if (exception.response) {
        error = exception.response.data.error.description
      }
      if (text) {
        error = text
      }
      return this.$vs.notify({
        title,
        text: error,
        color: 'danger',
        position: 'top-right'
      })
    },
    lottiePlay (ref) {
      this.$refs[ref][0].play()
    },
    lottieStop (ref) {
      this.$refs[ref][0].stop()
    },
    saveChanges (challenge,index) {

      this.autoSave = {
        text: 'Saving...',
        status: 'pending'
      }

      setTimeout(() => {
        this.$vs.loading({
          color: '#FF9F43',
          background: 'transparent',
          container: '#pendingLoadingCircle',
          scale: 0.325,
          type: 'point'
        })
      }, 1)

      let error = false
      if (challenge) {
        this.$http.post(`practice/challenges/${challenge.id}`, challenge)
          .then(response => {
            if (response.status === 200) {
              if(response.data.data) {
                this.lessonData.challenges[index] = response.data.data
              }
            }
          })
          .catch(() => {
            this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
            return error = true
          })
      }

      if(error === true) {
        return this.autoSave = {
          text: 'Error While Saving Changes',
          status: 'error'
        }
      }

      setTimeout(() => {
        this.$vs.loading.close('#pendingLoadingCircle> .con-vs-loading')
        const date = new Intl.DateTimeFormat('en-US', {hour: 'numeric', minute: 'numeric', second: 'numeric'})
        this.autoSave = {
          text: `All Changes Saved - ${date.format(new Date())}`,
          status: 'success'
        }
      }, 2500)

    }
  },
  created () {
    this.fetchLessonDetails(this.$route.params.lessonId)
  },


}
</script>

<style lang="scss">


.theme-midnight {
  #CreateChallengePopup {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }

  #GapFillGenerator {
    .vs-switch {
      background: #fd4445;

      &.vs-switch-active {
        background: rgba(var(--vs-success), 1) !important;
      }
    }

    input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }
}

.theme-dark {
  #CreateChallengePopup {
    input.vs-inputx.vs-input--input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }

  #GapFillGenerator {
    .vs-switch {
      background: #fd4445;

      &.vs-switch-active {
        background: rgba(var(--vs-success), 1) !important;
      }
    }

    input {
      background: #1B1E22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }

    }
  }
}


</style>
